import { useContext, useEffect, useRef } from 'react';

import { ModalContext } from '../ModalManager';
import { subscribeAcceptance, ACCEPTANCE_TYPES } from '../../../libs/userAcceptance';
import { ACCEPTANCE_MODAL } from '../../../hooks/useAcceptance';

/**
 * Filet de sécurité des acceptations de la charte : ouvre la modale quand l'API a refusé une
 * publication (code `ACCEPTANCE_REQUIRED`), pour les chemins qui ne sont pas gatés au clic — onglet
 * dont le cache `currentUser` date d'avant la mise en service, client non à jour.
 *
 * ⚠️ Cette voie ne rejoue PAS l'action : la mutation a déjà échoué et son contexte est perdu. Le
 * membre accepte puis reclique. C'est bien pourquoi le gate au clic (`guard`) reste la voie
 * normale, et celle-ci un rattrapage.
 *
 * Ne rend rien ; à monter une seule fois, SOUS le ModalManager (cf. src/index.js). L'émetteur est
 * le MutationCache de React Query, qui vit hors de l'arbre React et ne peut pas ouvrir de modale
 * lui-même.
 */
const AcceptanceListener = () => {
    const { openModal } = useContext(ModalContext);

    // Le ModalManager recrée `openModal` à chaque rendu : passer par une ref évite de
    // désabonner/réabonner en boucle.
    const openModalRef = useRef(openModal);
    openModalRef.current = openModal;

    useEffect(() => subscribeAcceptance((type) => openModalRef.current(ACCEPTANCE_MODAL, {
        type: type || ACCEPTANCE_TYPES.MEDIA,
    })), []);

    return null;
};

export default AcceptanceListener;
